import api from "../../../../../service/api";


/**
 * Fetch student signatures
 *
 * @param {string|number} studentId - student identifier
 * @param {object} params - additional query params
 * @returns {Promise<object>} API response data
 */
export async function getStudentSignatures({studentId}) {
    const query = {studentId};
    // api.get will attach auth header and serialize params
    return api.get("tms/student/signature", query);
}

export async function getUserSignatures({id}) {

    return api.get(`tms/user/signature/${id}`);
}

export async function saveUserSignature({ userId, payload }) {
    return api.post("tms/user/signature/save", {
        ...payload,
        userId,
    });
}



export default {
    getStudentSignatures,
};
